module.exports = __webpack_public_path__ + "img/orderSiteDistributionMiddle@1x.35f6d4d8.png";